<template>
  <el-dialog
    title="编辑药品"
    :visible.sync="dialogdrugs"
    width="820px"
    style="text-align: left"
    :close-on-click-modal="false"
    @open="opendialog"
  >
    <div>
      <el-form
        :model="ruleForm"
        :inline="true"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm myform"
      >
        <div class="align-center">
          <div class="itemtitle">
            药房名称
            <span style="font-weight: 400; margin-left: 30px">
              {{ hospitalName }}</span
            >
          </div>
        </div>

        <div class="itemtitle">药品属性</div>
        <el-form-item label="药品名称" prop="goods_name">
          <el-input
            v-model="ruleForm.goods_name"
            placeholder="请输入"
            maxlength="10"
            class="myinput"
          ></el-input>
        </el-form-item>
        <el-form-item label="药品编码">
          <el-input
            v-model="ruleForm.drug_code"
            placeholder="请输入"
            maxlength="20"
            class="myinput"
          ></el-input>
        </el-form-item>
        <!-- 1中药 2中成药 3西药 -->
        <el-form-item label="类型" prop="goods_type">
          <el-select v-model="ruleForm.goods_type" disabled class="myinput">
            <el-option
              v-for="item in goods_type_list"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="剂型" prop="dosage_form">
          <el-select
            v-model="ruleForm.dosage_form"
            @change="dosageChange"
            class="myinput"
          >
            <el-option
              v-for="item in dosage_form_list"
              :key="item.drug_type"
              :label="item.drug_type_name"
              :value="item.drug_type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通用名称" prop="generic_name">
          <el-select
            class="myinput"
            v-model="ruleForm.generic_name"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词搜索"
            :remote-method="remoteMethod"
            :loading="loading"
            @change="changeName"
          >
            <el-option
              v-for="item in drug_id_list"
              :key="item.value"
              :label="item.generic_name"
              :value="item.drug_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="药品厂家" prop="productor">
          <el-input
            v-model="ruleForm.productor"
            placeholder="请输入"
            class="myinput"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item prop="dosage_data">
          <span slot="label">
            <el-tooltip
              class="item"
              effect="dark"
              content="散装规格主要用于发药机发药，规格重量输入1"
              placement="top"
            >
              <span style="cursor: pointer">
                <span>规格</span>
                <i class="el-icon-warning-outline"></i>
              </span>
            </el-tooltip>
          </span>
          <el-select
            v-model="ruleForm.dosage_data"
            style="width: 95px"
            value-key="dosage_unit_name"
          >
            <el-option
              v-for="item in dosage_unit_list"
              :key="item.value"
              :label="item.dosage_unit_name"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="dosage_num">
          <el-input
            v-model="ruleForm.dosage_num"
            placeholder="单个规格药品重量"
            style="width: 160px"
          >
            <span slot="suffix">g</span>
          </el-input>
        </el-form-item>
        <el-form-item label="当量" prop="conversion">
          <el-input
            v-model="ruleForm.conversion"
            placeholder="请输入"
            class="myinput"
          ></el-input>
        </el-form-item>
        <el-form-item label="有效期" prop="expiry_date">
          <el-date-picker
            class="myinput"
            v-model="ruleForm.expiry_date"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <div class="red" style="margin-left: 10px">有效期达到90天内预警</div>
        </el-form-item>
        <el-form-item
          v-if="drug_type_pid == 1"
          label="是否为国标"
          prop="is_national_standard"
        >
          <el-radio-group v-model="ruleForm.is_national_standard">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="itemtitle">药品价格</div>
        <el-form-item prop="cost_price">
          <span slot="label">
            <el-tooltip
              class="item"
              effect="dark"
              content="中药颗粒散装规格录入一克中药饮片价格，袋装规格录入每袋药品价格"
              placement="top"
            >
              <span style="cursor: pointer">
                <span>成本价</span>
                <i class="el-icon-warning-outline"></i>
              </span>
            </el-tooltip>
          </span>
          <el-input
            v-model="ruleForm.cost_price"
            placeholder="请输入"
            class="myinput"
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item prop="price">
          <span slot="label">
            <el-tooltip
              class="item"
              effect="dark"
              content="中药颗粒散装规格录入一克中药饮片价格，袋装规格录入每袋药品价格"
              placement="top"
            >
              <span style="cursor: pointer">
                <span>销售价</span>
                <i class="el-icon-warning-outline"></i>
              </span>
            </el-tooltip>
          </span>
          <el-input
            v-model="ruleForm.price"
            placeholder="请输入"
            class="myinput"
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <div class="itemtitle">库存信息</div>
        <el-form-item label="期初库存" prop="stock_opening">
          <el-input
            v-model="ruleForm.stock_opening"
            placeholder="请输入"
            class="myinput"
            @change="changeStock"
          ></el-input>
        </el-form-item>
        <el-form-item label="理论库存" prop="stock">
          <el-input
            v-model="ruleForm.stock"
            placeholder="请输入"
            class="myinput"
          ></el-input>
        </el-form-item>
        <el-form-item prop="stock_warning">
          <span slot="label">
            <el-tooltip
              class="item"
              effect="dark"
              content="预警值能及时提醒你药品不足，防止因无库存用户无法下单"
              placement="top"
            >
              <span style="cursor: pointer">
                <span>库存预警值</span>
                <i class="el-icon-warning-outline"></i>
              </span>
            </el-tooltip>
          </span>
          <el-input
            v-model="ruleForm.stock_warning"
            placeholder="请输入"
            class="myinput"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div
      style="text-align: right; padding: 0 50px 20px 0; box-sizing: border-box"
    >
      <el-button @click="dialogdrugs = false" style="width: 92px"
        >取 消</el-button
      >
      <el-button
        type="primary"
        @click="submitForm('ruleForm')"
        style="width: 92px"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import _ from "lodash";
import moment from "moment";
export default {
  data() {
    // let checkPrice = (rule, value, callback) => {
    //   if (value != '') {
    //     if (this.ruleForm.cost_price != '') {
    //       if (Number(value) <= Number(this.ruleForm.cost_price)) {
    //         callback(new Error('销售价须大于成本价'));
    //       } else {
    //         callback();
    //       }
    //     } else {
    //       callback();
    //     }
    //     callback();
    //   } else {
    //     callback();
    //   }
    // };
    return {
      dialogdrugs: false,
      loading: false,
      ruleForm: {
        goods_name: "",
        drug_code: "",
        dosage_form: 1,
        goods_type: 1,
        productor: "四川新绿药有限公司",
        cost_price: "",
        price: "",
        stock_opening: "",
        stock: "",
        stock_warning: "",
        expiry_date: "",
        dosage_unit: "",
        dosage_num: "",
        drug_id: "",
        conversion: "",
        generic_name: "",
        dosage_data: "",
        is_national_standard: 0,
      },
      goods_type_list: [
        { label: "中药", value: 1 },
        { label: "中成药", value: 2 },
        { label: "西药", value: 3 },
      ],
      dosage_form_list: [],
      dosage_unit_list: [
        { label: "散装", value: 2 },
        { label: "袋装", value: 1 },
      ],
      drug_id_list: [],
      rules: {
        goods_name: [
          {
            required: true,
            message: "请输入药品名称",
            trigger: "blur",
          },
        ],
        goods_type: [
          {
            required: true,
            message: "请选择药品类型",
            trigger: "blur",
          },
        ],
        dosage_form: [
          {
            required: true,
            message: "请选择药品剂型",
            trigger: "blur",
          },
        ],
        drug_id: [
          {
            required: true,
            message: "请选择通用名称",
            trigger: "blur",
          },
        ],
        dosage_data: [
          {
            required: true,
            message: "请选择规格单位",
            trigger: "blur",
          },
        ],
        dosage_num: [
          {
            required: true,
            message: "请输入规格药品重量",
            trigger: "blur",
          },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/,
            message: "最多保留两位小数",
            trigger: ["blur", "change"],
          },
        ],
        expiry_date: [
          {
            required: true,
            message: "请选择有效期",
            trigger: "blur",
          },
        ],
        productor: [
          {
            required: true,
            message: "请输入药品厂家",
            trigger: "blur",
          },
        ],
        conversion: [
          {
            required: true,
            message: "请输入药品当量",
            trigger: "blur",
          },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/,
            message: "最多保留两位小数",
            trigger: ["blur", "change"],
          },
        ],
        cost_price: [
          {
            required: true,
            message: "请输入药品成本价",
            trigger: "blur",
          },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,4})?$/,
            message: "请输入4位小数以内数字",
            trigger: ["blur", "change"],
          },
        ],
        price: [
          {
            required: true,
            message: "请输入药品销售价",
            trigger: "blur",
          },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,4})?$/,
            message: "请输入4位小数以内数字",
            trigger: ["blur", "change"],
          },
        ],
        stock_opening: [
          {
            required: true,
            message: "请输入药品期初库存",
            trigger: "blur",
          },
          {
            pattern: /^\d*\.?\d{0,1}$/,
            message: "支持小数点及小数点后一位小数输入",
            trigger: ["blur", "change"],
          },
        ],
        stock: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
          {
            pattern: /^\d*\.?\d{0,1}$/,
            message: "支持小数点及小数点后一位小数输入",
            trigger: ["blur", "change"],
          },
        ],
        stock_warning: [
          {
            pattern: /^\d{0,6}$/,
            message: "请输入6位以内正整数",
            trigger: ["blur", "change"],
          },
        ],
      },
      drug_type_pid: -1,
    };
  },
  watch: {
    isFlag() {
      this.dialogdrugs = true;
    },
  },
  props: ["isFlag", "goodsId", "hospitalName"],
  methods: {
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = _.omit(this.ruleForm, [
            "generic_name",
            "hospital_name",
            "dosage_data",
          ]);
          data.dosage_unit = this.ruleForm.dosage_data.dosage_unit;
          data.dosage_unit_name = this.ruleForm.dosage_data.dosage_unit_name;
          this.axios
            .post("platform/Goods/saveHospitalGoods", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("提交成功");
                this.dialogdrugs = false;
                this.$emit("refreshList");
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //实时搜索通用名
    remoteMethod(query) {
      let keywords = query;
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.axios
            .post("platform/Goods/getDrugList", { keywords })
            .then((res) => {
              if (res.code == 0) {
                this.drug_id_list = res.data.list;
              } else {
                this.drug_id_list = [];
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }, 200);
      } else {
        this.drug_id_list = [];
      }
    },
    //通用名改变
    changeName(value) {
      this.ruleForm.drug_id = value;
    },
    //获取药品规格
    getUnit() {
      this.axios
        .post("platform/Admin/getUnit", {
          page: 1,
          pageNumber: 10000,
        })
        .then((res) => {
          this.dosage_unit_list = res.data;
        });
    },
    //获取详情
    opendialog() {
      this.getUnit();
      let goods_id = this.goodsId;
      this.axios
        .post("platform/Goods/getHospitalGoodsInfo", { goods_id })
        .then((res) => {
          if (res.code == 0) {
            this.getDosageList(res.data.info.hospital_id);
            let ruleForm = _.pick(res.data.info, [
              "hospital_id",
              "goods_id",
              "drug_code",
              "goods_name",
              "dosage_form",
              "goods_type",
              "productor",
              "cost_price",
              "price",
              "stock",
              "stock_warning",
              "dosage_num",
              "drug_id",
              "generic_name",
              "conversion",
              "expiry_date",
              "stock_opening",
              "hospital_name",
              "dosage_unit",
              "dosage_unit_name",
              "is_national_standard",
            ]);
            ruleForm.dosage_data = {
              dosage_unit: res.data.info.dosage_unit,
              dosage_unit_name: res.data.info.dosage_unit_name,
            };
            if (ruleForm.expiry_date) {
              ruleForm.expiry_date = moment
                .unix(ruleForm.expiry_date)
                .format("yyyy-MM-DD");
            }
            this.ruleForm = ruleForm;
          }
        });
    },
    changeStock(e) {
      this.$set(this.ruleForm, "stock", e);
    },
    //获取可选剂型列表
    getDosageList(id) {
      if (!this.ruleForm.hospital_id && !id) {
        return false;
      }
      let hospital_id = this.ruleForm.hospital_id || id;
      this.axios
        .post("platform/Goods/getHospitalDrugTypeList", { hospital_id })
        .then((res) => {
          this.dosage_form_list = res.data.list;
          this.dosageChange(this.ruleForm.dosage_form);
        });
    },
    dosageChange(val) {
      console.log(val);
      let list = this.dosage_form_list.filter((item) => {
        return item.drug_type == val;
      });
      this.drug_type_pid = list[0].drug_type_pid;
    },
  },
};
</script>
<style lang="scss" scoped>
.myform {
  padding: 20px 30px;
  box-sizing: border-box;
}
.itemtitle {
  font-size: 16px;
  color: #333;
  font-weight: 600;
  margin-bottom: 24px;
}
.myinput {
  width: 266px;
}
</style>
